<script>
import {mapState} from "vuex";
import {required} from "vuelidate/lib/validators";
import Vue from "vue";
import {VueRecaptcha} from 'vue-recaptcha';
import minLength from "vuelidate/lib/validators/minLength";
import maxLength from "vuelidate/lib/validators/maxLength";
import sameAs from "vuelidate/lib/validators/sameAs";
import axios from "axios";
import moment from "moment";
import Drawer from "vue-simple-drawer";
import {thongTinTrangModel} from "@/models/thongTinTrangModel";
import Multiselect from "vue-multiselect";

const defaultProps = {
  hex: '#2b569a',
};


/**
 * Crypto ICO-landing page
 */
export default {
  components: {},
  data() {
    return {
      data: [],
      openRightDrawer: false,
      start: "",
      end: "",
      interval: "",
      days: "",
      minutes: "",
      hours: "",
      seconds: "",
      starttime: "Nov 5, 2020 15:37:25",
      endtime: "Dec 31, 2021 16:37:25",
      showModal: false,
      showRegisterModal: false,
      showForgotModal: false,
      showNotify: false,
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      capcha: null,
      modelRegister: {
        fullName: "nhat",
        userName: "nhat",
        soDienThoai: "0",
        email: 0,
        password: "Nhat1305@",
        confirmPassword: "Nhat1305@",
        phoneNumber: 0,

      },
      modelLogin: {
        userName: null,
        password: null
      },
      currentUserAuth: null,
      isShow: false,
      url: process.env.VUE_APP_API_URL + 'files/view/',
      showPDF: false,
      pdfID: '',
      toltip: null,
      file: {
        id: null,
        fileId: null,
        fileName: null,
        ext: ".pdf"
      },
      otpShow: false,
      verifyOpt: {
        sender: "du.tranphuoc@gmail.com",
        receiver: "0836980284",
        token: ""
      },
      sendSmsOtp: {
        sender: "du.tranphuoc@gmail.com",
        receiver: "0836980284",
        applicationTitle: "Test DGov"
      },
      accessToken: null,
      tempUser: null,
      showButtonSendOTP: true,
      event: null,
      thongtin: thongTinTrangModel.baseJson(),
      listLinhVuc : [],
      itemFilter: {
        Content : null,
        Level : null,
        Administration :null,
        Domain:null
      },
    };
  },
  validations: {
    modelRegister: {
      userName: {required},
      fullName: {required},
      phoneNumber: {required},
      password: {
        required,
        valid: function (value) {
          const containsUppercase = /[A-Z]/.test(value)
          const containsLowercase = /[a-z]/.test(value)
          const containsNumber = /[0-9]/.test(value)
          const containsSpecial = /[#?!@$%^&*-]/.test(value)
          return containsUppercase && containsLowercase && containsNumber && containsSpecial
        },
        minLength: minLength(8),
        maxLength: maxLength(19),
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs("password")
      },
    },
    modelLogin: {
      userName: {required},
      password: {required},
    },
    verifyOpt: {
      sender: {required},
      receiver: {required},
      token: {
        required,
        valid: function (value) {
          const containsNumber = /[0-9]/.test(value)
          return containsNumber
        },
        minLength: minLength(6),
        maxLength: maxLength(6),
      },
    }
  },
  created() {
    this.getAllLinhVuc("ALL");
    this.getThongTin();
    window.addEventListener("scroll", this.windowScroll);
    let authUser = localStorage.getItem("auth-user");
    if (authUser) {
      let jsonUserCurrent = JSON.parse(authUser);
      this.currentUserAuth = jsonUserCurrent;
     console.log("CURRENT USER AUTH  created : ", this.currentUserAuth)
    }
   // this.getThongTin();
 //   this.getFile();
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  },
  mounted() {
    // this.start = new Date(this.starttime).getTime();
    // this.end = new Date(this.endtime).getTime();
    // // Update the count down every 1 second
    // this.timerCount(this.start, this.end);
    // this.interval = setInterval(() => {
    //   this.timerCount(this.start, this.end);
    // }, 1000);
  },
  computed: {
    ...mapState('snackBarStore', ['notify', 'registerModal'])
  },
  methods: {

    async getAllLinhVuc(code) {
      await this.$store.dispatch("syncStore/getAllLinhVuc", code).then((res) => {
        this.listLinhVuc = res.data.data || [];
      })
    },

    async getThongTin(){
      let promise =  this.$store.dispatch("thongtinTrangStore/getAll")
      return promise.then(resp => {
        console.log("CC: ", resp.data)
           this.thongtin = resp.data
      })
    },
    handleToggleDrawer() {
      this.$refs.drawerLayout.toggle();
    },
    toggle() {
      this.open = !this.open;
    },

    rightDrawer() {
      this.openRightDrawer = !this.openRightDrawer;
    },
    Keymonitor(){
      var regex = /^[0-9]+$/;
      if(this.modelRegister.userName.match(regex)){
        this.modelRegister.phoneNumber = this.modelRegister.userName;
      }
    },
    onFinish() {
      this.showButtonSendOTP = true;
    //  console.log("abc show nè")
    },

    cache() {
    //  console.log('Cache Cleared');
    },
    alert() {
      alert('Clicked on alert icon');
    },
    async handleSubmitRegister(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.modelRegister.$invalid) {
     //   console.log("BBB:" ,this.$v.modelRegister)
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
     //   console.log("AAA:" , this.modelRegister)
        await this.$store.dispatch("userStore/create", this.modelRegister).then((res) => {
     //     console.log("LOG CREATE : " , res);
          if (res.code === 0) {
            this.showRegisterModal = false;
            this.tempUser = res.data;
            this.otpShow = true;
            this.modelRegister = {
              fullName: null,
              userName: null,
              password: null,
              address : null,
              confirmPassword: null,
              phoneNumber: null,
              email: null
            }
            this.$notify({
              group: "foo",
              title: "Thông báo",
              type: "success",
              text: res.message,
            });
            // this.$store.dispatch("snackBarStore/addNotification", notifyModel.addMessage(res, true))
          } else {
            console.log("LOG ELSE ")
            this.$notify({
              group: "foo",
              title: "Thông báo",
              type: "warn",
              text: res.message,
            });
          }
        });
        loader.hide();
      }
      this.submitted = false;
    },

    async handleSubmitLogin(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.modelLogin.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        await this.$store.dispatch("authStore/login", this.modelLogin).then((res) => {
          if (res.code === 0) {
            this.showModal = false;
            if (res.data.menu != null)
            {
              window.location.href = '/dashboard'
            }
            localStorage.setItem('auth-user', JSON.stringify(res.data));
            localStorage.setItem("user-token", JSON.stringify(res.data.accessToken));
            Vue.prototype.$auth_token = res.data.token;
            this.modelLogin = {
              userName: null,
              password: null
            }
            this.$notify({
              group: "foo",
              title: "Thông báo",
              type: "success",
              text: res.message,
            });
            let authUser = localStorage.getItem("auth-user");
            if (authUser) {

              let jsonUserCurrent = JSON.parse(authUser);
          //    console.log("LOG SUBMIT :  ", jsonUserCurrent)
              this.currentUserAuth = jsonUserCurrent;
         //     console.log("LOG SUBMIT 1231 :  ", this.currentUserAuth)
            }
       //     this.$store.dispatch("authStore/setCurrentUser", res.data.accessToken);
          } else {
            this.$notify({
              group: "foo",
              title: "Thông báo",
              type: "warn",
              text: res.message,
            });
          }
        });
        loader.hide();
      }
      this.submitted = false;
    },
    handleHideModal() {
      this.$store.dispatch("snackBarStore/addNotification", {isShow: false})
      this.$router.go({path: '/tao-phan-anh'});
    },
    timerCount: function (start, end) {
      // Get todays date and time
      var now = new Date().getTime();

      // Find the distance between now an the count down date
      var distance = start - now;
      var passTime = end - now;

      if (distance < 0 && passTime < 0) {
        clearInterval(this.interval);
        return;
      } else if (distance < 0 && passTime > 0) {
        this.calcTime(passTime);
      } else if (distance > 0 && passTime > 0) {
        this.calcTime(distance);
      }
    },
    calcTime: function (dist) {
      // Time calculations for days, hours, minutes and seconds
      this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(
          (dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
    },
    /**
     * Window scroll method
     */
    windowScroll() {
      const navbar = document.getElementById("navbar");
      if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
      ) {
        navbar.classList.add("nav-sticky");
      } else {
        navbar.classList.remove("nav-sticky");
      }
    },
    /**
     * Toggle menu
     */
    toggleMenu() {
      document.getElementById("topnav-menu-content").classList.toggle("show");
    },
    nextSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
    },
    prevSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    },
    logout() {
      console.log("work")
      // eslint-disable-next-line no-unused-vars
      var userLocalStorage = localStorage.getItem("user-token");
      if (userLocalStorage) {
        localStorage.removeItem("user-token");
        localStorage.removeItem("auth-user");
        Vue.prototype.$auth_token = null;
        this.$store.dispatch("authStore/setCurrentUser", null);
        window.location.href = "/"
        return;
      }
    },
    handlePushHoiDap() {
      console.log("LOG HANDLE PUSH")
      window.location.href = "https://paht.dongthap.gov.vn/tao-phan-anh"
    },
    handlePush(path) {
      let pathUrl = path ?? "/"
      if (pathUrl != window.location.pathname) {
        this.$router.push(pathUrl)
      }
    },
    submit(response) {
      this.capcha = response;
    },
    // async getThongTin() {
    //   let promise = this.$store.dispatch("thongTinStore/get")
    //   return promise.then(resp => {
    //     if (resp.data == null) {
    //       return []
    //     } else {
    //       this.isShow = resp.data.isShowSearchDonThu
    //       console.log("LOG IS SHOW ", this.isShow)
    //     }
    //   })
    // },

  },
  watch: {
    registerModal: {
      deep: true,
      handler(val) {
        console.log("val", val)
        this.showRegisterModal = true;
        this.showForgotModal = false;
        this.showModal = true
      }
    },
    modelRegister: {
      deep: true,
      handler(val){

      }
    }
  }
};
</script>
<template v-slot:cell(process)="data">
  <div class="layout-pakn position-relative">
    <div class="navbar-expand-lg sticky">
      <nav class="navbar navigation header-inner" id="navbar">
          <img src="../home/bg-header-sm.jpg" alt="">
      </nav>
      <nav class="navbar" id="navbar"
           style="background-color: #204b03; font-size: 18px; padding: 8px;">
        <div class="container cs-navbar-header">
          <a href="/" class="navbar-logo d-flex justify-content-center align-items-center">
            <img src="@/assets/images/5.png" alt height="40" class="logo logo-dark"/>
            <img src="@/assets/images/5.png" alt height="40" class="logo logo-light"/>
            <div class="cs-title-header" style="margin-left: 10px ">
              <p class="text-white text-uppercase mb-0">CHATBOT</p>
            </div>
          </a>
          <button
              type="button"
              class="btn btn-sm px-3 font-size-16 d-lg-none header-item r-guiphananh btn-collapse bd"
              data-toggle="collapse"
              data-target="#topnav-menu-content"
              @click="toggleMenu()"
          >
            <i class="mdi mdi-format-align-justify pd-5" style="color: #fff"></i>
          </button>
          <div class="collapse navbar-collapse" id="topnav-menu-content" style="text-transform: uppercase;"
          >
            <ul
                class="navbar-nav ms-auto"
                id="topnav-menu"
                v-scroll-spy-active="{ selector: 'a.nav-link' }"
            >
              <router-link
                  tag="li"
                  class="nav-item"
                  to="/"
              >
                <a class="nav-link">Trang chủ</a>
              </router-link>
              <router-link
                  tag="li"
                  class="nav-item"
                  to="/danh-sach-dich-vu-cong"
              >
                <a class="nav-link">Dịch vụ công</a>
              </router-link>
              <router-link
                  tag="li"
                  class="nav-item"
                  to="/gioi-thieu"
              >
                <a class="nav-link">Giới thiệu</a>
              </router-link>
                <a href="https://paht.dongthap.gov.vn/tao-phan-anh" target="_blank" class="nav-link" >Tạo phản ánh</a>
              <router-link
                  tag="li"
                  class="nav-item"
                  to="/lich-su"
              >
                <a class="nav-link">Lịch sử</a>
              </router-link>

            </ul>
            <div class="ms-lg-2">
              <b-dropdown
                  v-if="currentUserAuth"
                  right
                  variant="black"
                  toggle-class="header-item"
                  menu-class="dropdown-menu-end menu-congdan"
                  style="width: 100%"
              >
                <template v-slot:button-content>
                  <div style="display: flex; align-items: flex-start; justify-content: center">
                    <div class="d-flex align-items-center">

                    </div>
                    <div v-if="currentUserAuth.avatar != null">
                      <img
                          class="rounded-circle header-profile-user avatar-sm"
                          :src="url + `${currentUserAuth.avatar.fileId}`"
                          alt="Avatar"
                      />
                    </div>
                    <div v-else>
                      <img
                          class="rounded-circle header-profile-user"
                          src="@/assets/images/5.png"
                          alt="Avatar"
                      />
                    </div>

                  </div>
                </template>
                <!-- item-->
                <b-dropdown-item style="width: 100%">
                  <span class="d-xl-inline-block ms-1">
                        <div v-if="currentUserAuth">
                          <div
                              style="display: flex; flex-direction: column; justify-content: left; align-items: flex-start">
                            <div class="text-black font-weight-bold">{{ currentUserAuth.fullName }}</div>
                            <div style="font-size: 10px; color: black;">@{{ currentUserAuth.userName }}</div>
                          </div>
                        </div>
                        <div v-else class="text-black font-weight-bold">
                          Khách
                        </div>
                      </span>
                </b-dropdown-item>
                <hr class="my-1">
                <b-dropdown-item v-if="currentUserAuth != null && currentUserAuth.menu != null"
                    @click="handlePush('/dashboard')" style="width: 100%">
                  <i class="bx bx-user font-size-16 align-middle me-1"></i>
                  Vào trang quản trị
                </b-dropdown-item>
                <b-dropdown-item @click="handlePush('/thong-tin-ca-nhan-cong-dan')" style="width: 100%">
                  <i class="bx bx-user font-size-16 align-middle me-1"></i>
                  Thông tin cá nhân
                </b-dropdown-item>
                <b-dropdown-item @click="handlePush('/lich-su-cua-toi')" style="width: 100%">
                  <i class="bx bx-user font-size-16 align-middle me-1"></i>
                  Lịch sử hỏi đáp
                </b-dropdown-item>
                <a @click="logout" href="javascript:void(0)" class="dropdown-item text-danger">
                  <i
                      class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
                  ></i>
                  Đăng xuất
                </a>
              </b-dropdown>
              <button v-else type="button"
                      v-on:click="showModal = true, showRegisterModal = false, showForgotModal= false"
                      class="btn w-xs btn-login" style="text-transform: uppercase;">Đăng nhập
              </button>
            </div>
          </div>
        </div>
      </nav>
    </div>
    <div v-scroll-spy>
      <slot/>
      <!-- Footer start -->
      <footer class="landing-footer bg-footer">
        <div class="container">
          <div class="row d-flex align-items-center">
            <div class="col-md-4 col-sm-12">
              <div class="mb-4 d-flex justify-content-center">
                <img src="@/assets/images/5.png" alt height="100"/>
              </div>
            </div>
            <div class="col-md-8 col-sm-12 ">
              <div class="text-light">
                <p class="font-weight-bold">{{ this.thongtin.name }}</p>
                <p>Đơn vị chủ quản: {{ this.thongtin.donVi }}</p>
                <p>Địa chỉ: {{ this.thongtin.diaChi }}</p>
                <p>Điện thoại: {{ this.thongtin.soDienThoai }}</p>
              </div>
            </div>
          </div>
        </div>
        <b-modal
            v-model="showModal"
            title="Thông tin lĩnh vực"
            title-class="text-black font-18"
            body-class="p-3"
            hide-footer
            hide-header
            centered
            no-close-on-backdrop
            size="md"
            style="padding: 0px"
        >
          <Transition name="fade" mode="out-in">
            <div v-if="!showRegisterModal && !showForgotModal" class="row justify-content-center">
              <div class="col-md-12">
                <div class="card-login overflow-hidden" style="padding: 0px; margin-bottom: 0px; box-shadow: none">
                  <div class="bg-soft bg-primary"
                       style="background-image: url('/bg_login.jpg'); background-size: cover; height: 195px">
                    <div class="row" style=" background-color: rgba(40,136,59, 0.1)">
                      <div class="col-7" style="height: 150px">
                        <div class="text-primary p-4">
                        </div>
                      </div>
                      <div class="col-5 align-self-end">
                      </div>
                    </div>
                  </div>
                  <div class="card-body pt-0" style="padding: 10px 5px">
                    <div>
                      <router-link to="/" style="display: flex; justify-content: center">
                        <div class="avatar-md profile-user-wid mb-4">
                        <span class="avatar-title rounded-circle bg-light">
                        <img src="@/assets/images/5.png" alt height="80"/>
                        </span>
                        </div>
                      </router-link>
                    </div>
                    <b-alert
                        v-model="isAuthError"
                        variant="danger"
                        class="mt-3"
                        dismissible
                    >{{ authError }}
                    </b-alert
                    >
                    <b-form class="p-0" @submit.prevent="handleSubmitLogin" ref="formContainer">
                      <h4 style="text-align: center; margin-bottom: 20px"> Thông tin đăng nhập</h4>
                      <b-form-group
                          class="mb-3"
                          id="input-group-1"
                          label="Tài khoản"
                          label-for="input-1"
                      >
                        <b-form-input
                            id="input-1"
                            v-model="modelLogin.userName"
                            type="text"
                            placeholder="Nhập tên đăng nhập"
                            :class="{ 'is-invalid': submitted && $v.modelLogin.userName.$error }"
                        ></b-form-input>
                        <div
                            v-if="submitted && $v.modelLogin.userName.$error"
                            class="invalid-feedback"
                        >
                          <span v-if="!$v.modelLogin.userName.required">Tài khoản không được trống.</span>
                        </div>
                      </b-form-group>

                      <b-form-group
                          class="mb-3"
                          id="input-group-2"
                          label="Mật khẩu"
                          label-for="input-2"
                      >
                        <b-form-input
                            id="input-2"
                            v-model="modelLogin.password"
                            type="password"
                            placeholder="Nhập mật khẩu"
                            :class="{ 'is-invalid': submitted && $v.modelLogin.password.$error }"
                        ></b-form-input>
                        <div
                            v-if="submitted && !$v.modelLogin.password.required"
                            class="invalid-feedback"
                        >
                          Mật khẩu không được để trống!
                        </div>
                      </b-form-group>
                      <div style="display: flex; justify-content: space-between">
                        <b-form-checkbox
                            class="form-check"
                            id="customControlInline"
                            name="checkbox-1"
                            value="accepted"
                            unchecked-value="not_accepted"
                        >
                          Ghi nhớ đăng nhập
                        </b-form-checkbox>
                        <div class="text-center">
                          <p v-on:click="showForgotModal = true, showRegisterModal = false" class="text-muted"
                             style="cursor: pointer">
                            <i class="mdi mdi-lock me-1"></i> Quên mật khẩu
                          </p>
                        </div>
                      </div>
                      <!-- <div class="my-2 d-flex justify-content-center">
                        <vue-recaptcha @verify="submit"
                                       sitekey="6Le6ockiAAAAAKWc76PeZthq-hWy1as1h7ZlWsnE">

                        </vue-recaptcha>
                      </div> -->
                      <div class="row">
                        <div class="mt-1  col-md-6">
                          <b-button type="button" variant="danger" class="btn-block w-100"
                                    v-on:click="showModal = false"
                          >Thoát
                          </b-button
                          >
                        </div>
                        <div class="mt-1 col-md-6">
                          <b-button type="submit" variant="success" class="btn-block w-100"
                          >Đăng nhập
                          </b-button
                          >
                        </div>
                        <div class="mt-4  col-md-12">
                          <div style="text-align: center; margin: 0px">

                            <p
                                style="cursor: pointer"
                                v-on:click="showRegisterModal = true"
                                class="fw-medium text-primary"
                            >Đăng ký tài khoản</p
                            >
                          </div>
                        </div>
                      </div>

                    </b-form>
                  </div>
                  <!-- end card-body -->
                </div>
              </div>
              <!-- end col -->
            </div>
            <div v-if="showRegisterModal && !showForgotModal" class="row justify-content-center">
              <div class="col-md-12">
                <div class="card-register overflow-hidden" style="padding: 0px; margin-bottom: 0px; box-shadow: none">
                  <div class=" mb-5"
                       style="background-image: url('/bg_login.jpg'); background-size: cover; height: 195px">
                    <div class="row" style=" background-color: rgba(40,136,59, 0.1)">
                      <div class="col-7" style="height: 150px">
                        <div class="text-primary p-4">
                        </div>
                      </div>
                      <div class="col-5 align-self-end">
                      </div>
                    </div>
                  </div>
                  <div class="card-body pt-0" style="padding: 10px 5px">
                    <b-alert
                        v-model="isAuthError"
                        variant="danger"
                        class="mt-3"
                        dismissible
                    >{{ authError }}
                    </b-alert
                    >
                    <b-form class="p-0" @submit.prevent="handleSubmitRegister" ref="formContainer">
                      <div class="row">
                        <h4 style="text-align: center; margin-bottom: 20px"> Thông tin đăng ký</h4>

                        <div class="col-md-12">
                          <b-form-group
                              class="mb-3"
                              id="input-group-2"
                              label-for="input-2"
                          >
                            <label for="">Họ và Tên <span class="text-danger">*</span></label>
                            <b-form-input
                                id="input-2"
                                v-model="modelRegister.fullName"
                                type="text"
                                placeholder=""
                                :class="{ 'is-invalid': submitted && $v.modelRegister.fullName.$error }"
                            ></b-form-input>
                            <div
                                v-if="submitted && !$v.modelRegister.fullName.required"
                                class="invalid-feedback"
                            >
                              Tên không được để trống!
                            </div>
                          </b-form-group>
                        </div>

                        <div class="col-md-12">
                          <b-form-group
                              class="mb-3"
                              id="input-group-1"
                              label-for="input-1"
                          >
                            <label for="">Số điện thoại <span class="text-danger">*</span></label>
                            <b-form-input
                                id="input-1"
                                v-model="modelRegister.phoneNumber"
                                type="text"
                                placeholder=""
                                :class="{ 'is-invalid': submitted && $v.modelRegister.phoneNumber.$error }"
                            ></b-form-input>
                            <div
                                v-if="submitted && $v.modelRegister.phoneNumber.$error"
                                class="invalid-feedback"
                            >
                              <span
                                  v-if="!$v.modelRegister.phoneNumber.required">Số điện thoại không được bỏ trống!</span>
                            </div>
                          </b-form-group>
                        </div>
                        <div class="col-md-12">
                          <b-form-group
                              class="mb-3"
                              id="input-group-1"
                              label="Email"
                              label-for="input-1"
                          >
                            <b-form-input
                                id="input-1"
                                v-model="modelRegister.email"
                                type="text"
                                placeholder=""
                            ></b-form-input>
                          </b-form-group>
                        </div>

                        <div class="col-md-12">
                          <b-form-group
                              class="mb-3"
                              id="input-group-1"
                              label-for="input-1"
                          >
                            <label for="">Tên tài khoản <span class="text-danger">*</span></label>
                            <b-form-input
                                id="input-1"
                                v-model="modelRegister.userName"
                                type="text"
                                placeholder=""
                                @keydown.enter.prevent="Keymonitor"
                                @keydown.tab.prevent="Keymonitor"
                                @click="Keymonitor"
                                :class="{ 'is-invalid': submitted && $v.modelRegister.userName.$error }"
                            ></b-form-input>
                            <div
                                v-if="submitted && $v.modelRegister.userName.$error"
                                class="invalid-feedback"
                            >
                              <span v-if="!$v.modelRegister.userName.required"> Tài khoản không được trống!</span>
                            </div>
                          </b-form-group>
                        </div>

                        <div class="col-md-12">
                          <b-form-group
                              class="mb-3"
                              id="input-group-1"
                              label-for="input-1"
                          >
                            <label for="">Địa chỉ </label>
                            <b-form-input
                                id="input-1"
                                v-model="modelRegister.address"
                                type="text"
                                placeholder=""
                                @keydown.enter.prevent="Keymonitor"
                                @keydown.tab.prevent="Keymonitor"
                                @click="Keymonitor"
                                :class="{ 'is-invalid': submitted && $v.modelRegister.userName.$error }"
                            ></b-form-input>
                          </b-form-group>
                        </div>

                        <div class="col-md-6">
                          <b-form-group
                              class="mb-3"
                              id="input-group-1"
                              label-for="input-1"
                          >
                            <label for="">Mật khẩu <span class="text-danger">*</span></label>
                            <b-form-input
                                id="input-1"
                                v-model="modelRegister.password"
                                type="password"
                                placeholder=""
                                :class="{ 'is-invalid': submitted && $v.modelRegister.password.$error }"
                            ></b-form-input>
                            <div
                                v-if="submitted && $v.modelRegister.password.$error"
                                class="invalid-feedback"
                            >
                              <span v-if="!$v.modelRegister.password.required">Mật khẩu không được để trống!</span>
                              <span v-else>Nhập mật khẩu có tối thiểu 8 kí tự bao gồm in hoa in thường và kí tự đặc biệt!</span>
                            </div>
                          </b-form-group>
                        </div>
                        <div class="col-md-6">
                          <b-form-group
                              class="mb-3"
                              id="input-group-2"
                              label-for="input-2"
                          >
                            <label for="">Nhập lại mật khẩu <span class="text-danger">*</span></label>
                            <b-form-input
                                id="input-2"
                                v-model="modelRegister.confirmPassword"
                                type="password"
                                placeholder=""
                                :class="{ 'is-invalid': submitted && $v.modelRegister.confirmPassword.$error }"
                            ></b-form-input>
                            <div
                                v-if="submitted && !$v.modelRegister.confirmPassword.required"
                                class="invalid-feedback"
                            >
                              Mât khẩu không được để trống!
                            </div>
                            <div
                                v-if="submitted && !$v.modelRegister.confirmPassword.sameAsPassword"
                                class="invalid-feedback"
                            >
                              Mật khẩu nhập lại không đúng!
                            </div>
                          </b-form-group>
                        </div>
                      </div>
                      <!-- <div class="my-2 d-flex justify-content-center">
                        <vue-recaptcha @verify="submit"
                                       sitekey="6Le6ockiAAAAAKWc76PeZthq-hWy1as1h7ZlWsnE"></vue-recaptcha>
                      </div> -->
                      <div class="row">
                        <div class="mt-1  col-md-6">
                          <b-button type="button" variant="danger" class="btn-block w-100"
                                    v-on:click="showModal = false"
                          >Thoát
                          </b-button
                          >
                        </div>
                        <div class="mt-1 col-md-6">
                          <b-button type="submit" variant="success" class="btn-block w-100"
                          >Đăng ký
                          </b-button
                          >
                        </div>
                        <div class="mt-4  col-md-12">
                          <div style="text-align: center; margin: 0px">

                            <p
                                style="cursor: pointer"
                                v-on:click="showRegisterModal = false"
                                class="fw-medium text-primary"
                            >Đăng nhập vào hệ thống</p
                            >
                          </div>
                        </div>
                      </div>

                    </b-form>
                  </div>
                  <!-- end card-body -->
                </div>
              </div>
              <!-- end col -->
            </div>
            <div v-if="showForgotModal" class="row justify-content-center">
              <div class="col-md-12">
                <div class="card overflow-hidden" style="padding: 0px; margin-bottom: 0px; box-shadow: none">
                  <div class="bg-soft bg-primary"
                       style="background-image: url('/bg_login.jpg'); background-size: cover; height: 195px">
                    <div class="row" style=" background-color: rgba(40,136,59, 0.1)">
                      <div class="col-7" style="height: 150px">
                        <div class="text-primary p-4">
                          <!--                        <h5 class="text-primary">Welcome Back !</h5>-->
                          <!--                        <p>Sign in to continue to Skote.</p>-->
                        </div>
                      </div>
                      <div class="col-5 align-self-end">
                        <!--                      <img-->
                        <!--                          src="@/assets/images/profile-img.png"-->
                        <!--                          alt-->
                        <!--                          class="img-fluid"-->
                        <!--                      />-->
                      </div>
                    </div>
                  </div>
                  <div class="card-body pt-0" style="padding: 10px 5px">
                    <div>
                      <router-link to="/" style="display: flex; justify-content: center">
                        <div class="avatar-md profile-user-wid mb-4">
                        <span class="avatar-title rounded-circle bg-light">
                        <img src="@/assets/images/5.png" alt height="80"/>
                        </span>
                        </div>
                      </router-link>
                    </div>
                    <b-alert
                        v-model="isAuthError"
                        variant="danger"
                        class="mt-3"
                        dismissible
                    >{{ authError }}
                    </b-alert
                    >
                    <b-form class="p-0" @submit.prevent="tryToLogIn">
                      <div class="row">
                        <h4 style="text-align: center; margin-bottom: 20px"> Lấy lại mật khẩu</h4>
                        <div class="col-md-12">
                          <b-form-group
                              class="mb-3"
                              id="input-group-1"
                              label="Số điện thoại"
                              label-for="input-1"
                          >
                            <b-form-input
                                id="input-1"
                                v-model="email"
                                type="text"
                                placeholder=""
                                :class="{ 'is-invalid': submitted && $v.email.$error }"
                            ></b-form-input>
                            <div
                                v-if="submitted && $v.email.$error"
                                class="invalid-feedback"
                            >
                              <span v-if="!$v.email.required">Email is required.</span>
                              <span v-if="!$v.email.email">Please enter valid email.</span>
                            </div>
                          </b-form-group>
                        </div>
                      </div>

                      <div class="row">
                        <div class="mt-1  col-md-6">
                          <b-button type="button" variant="danger" class="btn-block w-100"
                                    v-on:click="showModal = false"
                          >Thoát
                          </b-button
                          >
                        </div>
                        <div class="mt-1 col-md-6">
                          <b-button type="submit" variant="danger" class="btn-block w-100"
                          >
                            Gửi thông tin
                          </b-button
                          >
                        </div>
                        <div class="mt-4  col-md-12">
                          <div style="text-align: center; margin: 0px">

                            <p
                                style="cursor: pointer"
                                v-on:click="showRegisterModal = true, showForgotModal = false"
                                class="fw-medium text-primary"
                            >Đăng nhập vào hệ thống</p
                            >
                          </div>
                        </div>
                      </div>

                    </b-form>
                  </div>
                  <!-- end card-body -->
                </div>
              </div>
              <!-- end col -->
            </div>
          </Transition>
        </b-modal>
      </footer>
      <!-- Footer end -->
    </div>
    <!-- <div class="floating-button">
      <div class="d-flex flex-column">
        <div class="position-relative">
          <a
              id="gui-phan-anh"
              @click="rightDrawer"
              class="glow-on-button btn-gpa text-uppercase"
              v-on:mouseover="toltip = 'GPA'"
              v-on:mouseout="toltip = null"
          >
            <i class="mdi mdi-wechat" id="btnclose" style="font-size: 50px;"></i>
          </a>
          <div class="toltip-gpa" v-if="toltip === 'GPA'">Chatbot</div>
        </div>
      </div>
    </div> -->
    <!-- <Drawer
        @close="rightDrawer"
        :align="'right'"
        :closeable="true"
        :maskClosable="true"
        :zIndex="1002"
      >
        <div v-if="openRightDrawer">
          <div class="row">
            <form role="form">
              <div class="col-12 mt-3">
                  <div class="row mb-3">
                      <div class="col-12 mb-3">
                          <h5 class="font-weight-bold fs-2 title-chat">CHATBOT</h5>
                      </div>
                      <div class="col-md-3 col-lg-3">
                          <label class="text-black"> Họ và tên </label>
                      </div>
                      <div  class="col-md-9 col-lg-9">
                          <div>
                          <input
                              class="form-control"
                              type="text"
                              placeholder="Nhập họ và tên..."
                          />
                          </div>
                      </div>
                      </div>
                      <div class="row mb-3">
                      <div class="col-md-3 col-lg-3">
                          <label class="text-black"> Căn cước công dân </label>
                      </div>
                      <div class="col-md-9 col-lg-9">
                          <div >
                          <input
                              class="form-control"
                              type="text"
                              placeholder="Nhập căn cước công dân..."
                          />
                          </div>
                      </div>
                      </div>
                      <div class="row mb-3">
                      <div class="col-md-3 col-lg-3">
                          <label class="text-black">Lĩnh vực</label>
                      </div>
                      <div class="col-md-9 col-lg-9 fs-13">
                        <multiselect
                            v-model="itemFilter.Domain"
                            :options="listLinhVuc"
                            :multiple="false"
                            track-by="id"
                            class="helo"
                            selectLabel="Nhấn vào để chọn"
                            deselectLabel="Nhấn vào để xóa"
                            label="domainName"
                            placeholder="Chọn lĩnh vực"
                        ></multiselect>
                      </div>
                      </div>
                      <div class="row mb-3">
                      <div class="col-md-3 col-lg-3">
                          <label class="text-black">Nội dung </label>
                      </div>
                      <div class="col-md-9 col-lg-9">
                              <textarea
                                  class="form-control"
                                  type="search"
                                  rows="8"
                                  placeholder="Nhập nội dung..."
                              ></textarea>
                      </div>
                      </div>
                      <div class="row">
                      <div class="col-3"></div>
                      <div class="col-9">
                          <div class="mb-3 row">
                          <label class="col-md-3 col-form-label"></label>
                          <div class="col-md-9">
                                <router-link :to="{ name: 'Chat Mes',
                                    query: { data: JSON.stringify(data.item)}}">
                                  <b-button
                                      type="submit"
                                      class="font-weight-bold px-5 btn-chat"
                                      style="width: 200px;margin-right: 15px;border-radius: 20px; font-size: 18px;"
                                  >CHAT
                                  </b-button>
                                </router-link>

                          </div>
                          </div>
                      </div>
                  </div>
              </div>
            </form>
          </div>
        </div>
      </Drawer> -->

  </div>
</template>
<style lang="scss">

.header-inner img{
  width: 100%;
}
.navigation{
  padding: 0px !important;
  background-color: #fff !important;
  border-bottom: none !important;
}

textarea.form-control{
  height: 140px;
}

.title-chat{
  background-color: #204b03;
  padding: 10px;
  color: #fff;
}

.card-info{
    position: absolute;
    right: 0;
    bottom: 0;
    width: 1000px;
    display: none;
}

.card-right{
    background-color: #ccc;
}


.close{
    position: absolute;
    right: 10px;
    font-size: 40px;
    text-decoration: none !important;
    color: inherit;

}

.text-black{
    font-size: 13px;
}

.bd{
  border: 1px solid #fff;
  border-radius: 10px;
}


.bg-footer {
  min-height: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url("~@/assets/images/background-footer.png");
  background-size: cover;
  background-repeat: round;
  padding-top: 50px;
  padding-bottom: 30px;
}

.floating-button {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 999999999;

}

.glow-on-button {
  width: 70px;
  height: 70px;
  background: #204b03;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px;
}

.toltip-gpa,
.toltip-hdsd {
  position: absolute;
  top: 20%;
  padding: 5px 10px;
  background: #204b032e;
  color: #204b03;
  border-radius: 5px;
}

.toltip-gpa {
  left: -110px;
}

.toltip-hdsd {
  left: -150px;
}

.glow-on-button i {
  color: #fff !important;
  font-size: 16px;
}

@keyframes glowing {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 400% 0;
  }
  100% {
    background-position: 0 0;
  }
}
</style>

<style scoped>
#topnav-menu .nav-item a {
  font-size: 18px;
}

.dropdown-pakn:hover {
  border: none;
}

.dropdown-pakn:focus {
  border: none;
}

.dropdown-pakn .items-pakn {
  line-height: 28px;
}

.dropdown-pakn .items-pakn:hover {
  background-color: #d7e7e5;
}

</style>

<style>

.menu-congdan {
  width: 100% !important;
  min-width: 200px;
}

/*#topnav-menu .nav-link {*/
/*  color: #2a2a2a;*/
/*}*/

.bg-navbar-dark {
  background: rgba(204, 204, 204, 0.56);
}

.hero-section.bg-ico-hero {
  height: 500px;
}

li.router-link-exact-active {
  margin: 5px;
  border-radius: 5px;
}

#topnav-menu-content li.router-link-exact-active > a {
  color: #2a2a2a !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  background-color: #fff;
}

#topnav-menu-content a.nav-link {
  line-height: 38px !important;
  border-radius: 5px;
  color: #ffffff !important;
}

@media only screen and (max-width: 2560px) {
  .hero-section.bg-ico-hero {
    position: relative;
    height: 400px;
  }

  .banner-home .title-box {
    padding-top: 30px;
  }

  .hero-section.bg-ico-primary {
    height: 300px;
  }

  .r-guiphananh {
    position: absolute;
    padding: 0;
    bottom: 50px;
    left: 0px;
  }

  .hero-title {
    font-size: 38px !important;
    font-weight: bold;
    color: #2b569a;
  }

  .hero-action {
    display: none;
  }
}


@media only screen and (max-width: 1440px) {
  .hero-section.bg-ico-hero {
    position: relative;
    height: 300px;
  }


  .r-guiphananh {
    position: absolute;
    padding: 0;
    bottom: 50px;
    left: 0px;
  }

  .hero-section.bg-ico-primary {
    height: 300px;
    padding-top: 140px;
  }

  .hero-section.bg-ico-primary.banner-home {
    padding-top: 100px;
  }

  .hero-section.bg-ico-primary.contact-section {
    padding-top: 80px;
  }

  .contact-section .title-box h1 {
    font-size: 40px;
  }


  .hero-title {
    font-size: 22px !important;
    font-weight: bold;
  }

  .hero-action {
    display: none;
  }
}

@media only screen and (max-width: 1200px) {
  .hero-section.bg-ico-hero {
    height: 200px;
  }

  .r-guiphananh {
    bottom: 50px;
    left: 0px;
  }
}

@media only screen and (max-width: 1024px) {
  .hero-section.bg-ico-hero {
    height: 210px;
  }

  .contact-section .title-box {
    margin-top: 0px;
    padding-top: 40px;
  }

  .hero-section .title-box {
    margin-top: -40px;
  }

  .r-guiphananh {
    padding: 5px;
    bottom: 12px;
    left: 12px;
  }

  .hero-section.bg-ico-primary {
    height: 220px;
  }

  .hero-title {
    font-size: 22px !important;
    font-weight: bold;
    padding: 0 !important;
  }

  .hero-action {
    display: none;
  }

  .wr-show {
    display: none;
  }

}


@media only screen and (max-width: 768px) {
  .hero-section.bg-ico-hero {
    height: 150px;
    margin-top: 30px;
  }

  .cs-navbar-header {
    justify-content: end !important;
  }

  .hero-section .title-box {
    margin-top: -5px;
  }

  .contact-section .title-box {
    margin-top: 0px;
    padding-top: 0px;
  }

  .r-guiphananh {
    bottom: 3px;
    left: 0px;
  }

  .hero-section.banner-home {
    height: 200px !important;
    margin-top: 20px !important;
    padding-top: 30px !important;
  }

  .hero-section.bg-ico-primary {
    height: 150px;
    margin-top: 60px;
    padding-top: 30px !important;
  }
}

@media only screen and (max-width: 617px) {
  .hero-section.bg-ico-hero {
    height: 150px;
  }

  .hero-title {
    font-size: 16px !important;
    font-weight: bold;
  }
}

@media only screen and (max-width: 570px) {
  .hero-section.bg-ico-hero {
    height: 150px;
  }

  .hero-title {
    font-size: 16px !important;
    font-weight: bold;
  }
}

@media only screen and (max-width: 425px) {
  .hero-section.bg-ico-hero {
    height: 120px;
    padding: 0px;
    margin-top: 60px;
  }

  .hero-title.title-contact {
    margin-top: 20px !important;
    font-size: 30px !important;
  }
}

@media only screen and (max-width: 425px) {
  .hero-section.bg-ico-hero {
    height: 120px;
  }

  .hero-section.bg-ico-primary {
    height: 130px;
    margin-top: 60px;
  }

  .r-guiphananh {
    bottom: 20px;
  }

  .btn-guiphananh {
    font-size: 10px;
    padding: 5px;
  }

  .btn-custom {
    height: 20px;
    width: 100px;
    font-size: 10px;
    padding: 3px;
  }
}

@media only screen and (max-width: 375px) {
  .hero-section.bg-ico-hero {
    height: 90px;
  }

  .contact-section .title-box {
    margin-top: 60px;
  }

  .notify-section .title-box,
  .search-section .title-box {
    margin-top: 40px;
  }

  .hero-section.banner-home {
    height: 170px !important;
  }

  section#about {
    padding: 0px 10px;
  }


  .btn-guiphananh {
    padding: 4px;
    font-size: 12px;
  }

  .hero-section.bg-ico-primary {
    height: 170px;
    margin-top: 10px;
  }

  .r-guiphananh {
    bottom: 10px;
  }
}

@media only screen and (max-width: 320px) {
  .hero-section.bg-ico-hero {
    height: 80px;
  }

  .hero-section .hero-title {
    padding: 0px 20px !important;
  }

  .btn-guiphananh {
    margin-top: -15px;
  }
}

.text-primary-dark {
  color: #6E1511;
}

.icon_question {
  animation-name: spin, depth;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-duration: 3s;
}

@keyframes spin {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(-360deg);
  }
}


@keyframes depth {
  0% {
    text-shadow: 0 0 black;
  }
  25% {
    text-shadow: 1px 0 black, 2px 0 black, 3px 0 black, 4px 0 black, 5px 0 black;
  }
  50% {
    text-shadow: 0 0 black;
  }
  75% {
    text-shadow: -1px 0 black, -2px 0 black, -3px 0 black, -4px 0 black,
    -5px 0 black;
  }
  100% {
    text-shadow: 0 0 black;
  }
}

.btn-modal {
  background: linear-gradient(45deg, #F13F55, #F6C6C6);
  border: none;
  color: #fff;
}
</style>
<style lang="scss">
.success-checkmark {
  width: 80px;
  height: 115px;
  margin: 0 auto;

  .check-icon {
    width: 80px;
    height: 80px;
    position: relative;
    border-radius: 50%;
    box-sizing: content-box;
    border: 4px solid #4CAF50;

    &::before {
      top: 3px;
      left: -2px;
      width: 30px;
      transform-origin: 100% 50%;
      border-radius: 100px 0 0 100px;
    }

    &::after {
      top: 0;
      left: 30px;
      width: 60px;
      transform-origin: 0 50%;
      border-radius: 0 100px 100px 0;
      animation: rotate-circle 4.25s ease-in;
    }

    &::before, &::after {
      content: '';
      height: 100px;
      position: absolute;
      background: #FFFFFF;
      transform: rotate(-45deg);
    }

    .icon-line {
      height: 5px;
      background-color: #4CAF50;
      display: block;
      border-radius: 2px;
      position: absolute;
      z-index: 10;

      &.line-tip {
        top: 46px;
        left: 14px;
        width: 25px;
        transform: rotate(45deg);
        animation: icon-line-tip 0.75s;
      }

      &.line-long {
        top: 38px;
        right: 8px;
        width: 47px;
        transform: rotate(-45deg);
        animation: icon-line-long 0.75s;
      }
    }

    .icon-circle {
      top: -4px;
      left: -4px;
      z-index: 10;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      position: absolute;
      box-sizing: content-box;
      border: 4px solid rgba(76, 175, 80, .5);
    }

    .icon-fix {
      top: 8px;
      width: 5px;
      left: 26px;
      z-index: 1;
      height: 85px;
      position: absolute;
      transform: rotate(-45deg);
      background-color: #FFFFFF;
    }
  }
}

@keyframes rotate-circle {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}

@keyframes icon-line-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}

@keyframes icon-line-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0px;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
</style>
<style lang="scss">

.bg-home-primary {
  //background: url("../../assets/images/background_primary.png");
  background-size: cover;
  background-position: top;
  height: 200px;
  margin: auto;
  margin-top: 80px;
  @media (max-width: 575.98px) {
    height: 80px;
    & .content-title {
      padding: 0px 20px;
      font-size: 14px;
    }
  }
  @media (max-width: 575.98px) {
    height: 50px;
    & .content-title {
      padding: 0px 20px;
    }
  }

}

@media only screen and (max-width: 768px) {
  #topnav-menu-content {
    padding-bottom: 50px;
  }
}

.btn-login {
  background-color: #faf150 !important;
  color: #c71a16;
  text-shadow: 0px 0px 2px #fff;
}

.btn-login:focus,
.btn-login:hover {
  border: none !important;
  background: #faf150 !important;
  color: #c71a16;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset !important;
}

.btn-shape:focus,
.btn-shape:hover {
  border: none !important;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset !important;
}

.fs-15 {
  font-size: 15px !important;
}

.fs-13 {
  font-size: 13px !important;
}

.fs-warning {
  font-size: 13px;
  color: #ffa000;
  font-style: italic
}

.fs-cyan {
  font-size: 13px;
  color: #449d73;
  font-style: italic
}

.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.title-block-ellipsis {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  height: 43px;
  margin: 0 auto;
  font-size: 14px;
  line-height: 1;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.block-ellipsis {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  height: 80px;
  margin: 0 auto;
  font-size: 14px;
  line-height: 1;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cs-title-header span {
  font-size: 14px;
}

@media only screen and (max-width: 2560px) {
  .navbar-logo {
    line-height: 18px !important;
  }
}

@media only screen and (max-width: 1366px) {
  .navbar-logo {
    line-height: 18px !important;
  }
}

@media only screen and (max-width: 1200px) {
  .navbar-logo {
    line-height: 18px !important;
  }
}


@media only screen and (max-width: 991px) {
  .cs-navbar-header {
    justify-content: end !important;
  }
  .navbar-logo {
    width: 200px !important;
  }
}


@media only screen and (max-width: 1024px) {
  .cs-title-header {
    width: 200px;
  }
  .cs-title-header p {
    font-size: 14px;
  }
  .logo-dark {
    height: 40px;
  }
  .logo-light {
    height: 40px;
  }
  .navbar {
    padding: 10px 0px;
  }
  .navbar-logo {
    line-height: 18px !important;
  }
}

@media only screen and (max-width: 991px) {
  .btn-collapse {
    position: absolute;
    top: 10px;
    left: 10px;
    height: 40px;
  }
}

@media only screen and (max-width: 768px) {
  .btn-collapse {
    position: absolute;
    top: 10px;
    left: 10px;
    height: 40px;
  }
}

@media only screen and (max-width: 425px) {
  .logo-dark {
    margin-left: 30px;
  }
  .navbar-logo {
    width: 270px !important;
  }
  .cs-title-header {
    width: 150px;
  }

}

@media only screen and (max-width: 375px) {
  .cs-title-header {
    width: 100%;
  }
  .cs-title-header span {
    font-size: 14px;
  }
}

@media only screen and (max-width: 768px) {
  .btn-guiphananh {
    margin-bottom: 5px;
  }
}

.vue-simple-drawer.right{
  width: 50%;
  height: 65%;
  top: 35% !important;
}

.vue-simple-drawer.closeable{
  padding: 25px;
}
.btn-chat{
  background-color: #204b03 !important;
}
.multiselect--above .multiselect__content-wrapper{
  bottom: auto;
  top: 100%
}

.multiselect__option--highlight, .multiselect__option--highlight:after{
  background-color: #204b03 !important;
}


.navbar-collapse{
  height: 100% !important;
}

</style>
